<template>
  <aside class="sidebar">
    <section class="nav_sidebar">
      <nav>
        <ul class="navbar_menu list-unstyled">
          <!-- 二級 -->
          <li v-for="route in routes"
              :key="route.name">

            <!-- 主要可以點擊二級menu item -->
            <template v-if="route.children && route.meta.nested">
              <a class="menuDrop" :class="{active: checkPath(route.name, 'class')}" href="javascript:;"> <span>{{ $t('sidebar.'+ route.meta.title) }}</span></a>
            </template>

            <!-- 主要可以點擊一級menu item -->
            <template v-else>
              <router-link :to="route.path" v-if="route.children"  :id="'btnSider' + route.meta.title">
                <span>{{ $t('sidebar.'+ route.meta.title) }}</span>
              </router-link>
              <!-- reference, support -->
              <router-link :to="route.path+'/'+route.children[0].path"
      v-else-if="route.path !== '/service-tools' && route.path !== '/reference' && !(isLogin)">
                <span>{{ $t('sidebar.'+ route.meta.title) }}</span>
              </router-link>
            </template>

            <ul
              class="navbar_menu_child list-unstyled"
              :style="{display: checkPath(route.name, 'style')}"
              v-if="route.children && route.meta.nested"
            >
              <li v-for="childRoute in route.children"
                  :key="childRoute.name">
                <router-link :to="route.path+'/'+childRoute.path" :id="'btnSider'+ childRoute.meta.title">
                  {{ $t('sidebar.'+ childRoute.meta.title) }}
                  <span
                    v-if="childRoute.meta.title === 'serviceRecord' && getRecordsNotify"
                    class="tips">
                    {{ getRecordsNotify }}
                  </span>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </section>
  </aside>
</template>
<script>
export default {
  name: 'Sidebar',
  computed: {
    routes () {
      return this.$router.options.routes.filter(item => !item.hidden);
    },
    currentPath () {
      // // console.log("TCL: currentPath -> this.$route.matched[0].name", this.$route.matched)
      return this.$route.matched[0].name;
    }
  },
  methods: {
    checkPath (path, name) {
      if (this.currentPath === path && name === 'class') {
        return true;
      } else if (this.currentPath === path && name === 'style') {
        return 'block';
      } else {
        if (name === 'class') return false;
        else return 'none';
      }
    }
  }
};
</script>
